import api from "@/services/api";
import l10n from "@/services/l10n";
import errorHandler from "@/services/errorHandler";

import {
  SET_PLAYLISTS,
  DELETE_PLAYLIST,
  CLEAR_PLAYLISTS
} from "@/store/mutation-types";

export default {
  async fetch({ commit }, data = {}) {
    const { type, params } = data;
    const { payload = {} } = await api.playlists.fetch(type, params);
    const { playlists = [], playlist = {} } = payload;

    commit(SET_PLAYLISTS, type === "playlist" ? [playlist] : playlists);

    return payload;
  },
  clear({ commit }) {
    commit(CLEAR_PLAYLISTS);
  },
  async create({ dispatch }, data = {}) {
    try {
      await dispatch(
        "modal/open",
        { name: "newplaylist", data },
        { root: true }
      );
    } catch (error) {
      errorHandler.add(error);
      return false;
    }
  },
  async add({ commit }, data = {}) {
    try {
      const { title = "", tracks = [] } = data;

      if (title) {
        const { payload = {} } = await api.playlists.create({
          title,
          tracks
        });
        const { playlist } = payload;

        commit(SET_PLAYLISTS, [playlist]);

        this.$app.$message(l10n("PLAYLIST_CREATED", { title: playlist.title }));

        return playlist;
      }
    } catch (error) {
      errorHandler.add(error);

      return false;
    }
  },
  async remove({ commit, dispatch }, { id, type }) {
    try {
      const { confirm = false } = await dispatch(
        `modal/open`,
        {
          name: "confirm",
          data: {
            title: l10n("PLAYLIST_REMOVE"),
            caption: l10n("DONT_RECOVERED")
          }
        },
        { root: true }
      );

      if (confirm) {
        if (type === "full") {
          await this.$app.$router.push("/playlists");
        }

        await api.playlists.remove({ id });

        commit(DELETE_PLAYLIST, id);

        this.$app.$message(l10n("PLAYLIST_REMOVED"));
      }

      return { id, success: confirm };
    } catch (error) {
      errorHandler.add(error);

      return false;
    }
  },
  async addTracks({ commit }, { playlistId, tracksIds }) {
    try {
      if (!tracksIds.length) {
        this.$app.$message(l10n("TRACKLIST_IS_EMPTY"));
      }

      const { payload = {} } = await api.playlists.addTracks({
        id: playlistId,
        tracks: tracksIds
      });

      const { playlist = null } = payload;

      if (playlist) {
        commit(SET_PLAYLISTS, [playlist]);

        this.$app.$message(
          tracksIds.length > 1
            ? l10n("TRACKS_ADDED_TO_PLAYLIST")
            : l10n("TRACK_ADDED_TO_PLAYLIST")
        );
      }

      return playlist;
    } catch (error) {
      return this.$app.$errorHandler(error);
    }
  },
  async removeTrack({ commit }, { playlistId, trackId }) {
    try {
      const { payload = {} } = await api.playlists.removeTrack({
        id: playlistId,
        trackId
      });

      const { playlist = null } = payload;

      if (playlist) {
        commit(SET_PLAYLISTS, [playlist]);
        this.$app.$message(l10n("TRACK_DELETED_FROM_PLAYLIST"));
      }

      return playlist;
    } catch (error) {
      errorHandler.add(error);

      return false;
    }
  },
  async update({ commit }, params) {
    const { payload = {} } = await api.playlists.update(params);
    const { playlist = null } = payload;

    if (playlist) {
      commit(SET_PLAYLISTS, [playlist]);
    }

    return playlist;
  },
  async updateCover({ commit }, params) {
    const { payload = {} } = await api.playlists.cover(params);
    const { playlist = {} } = payload;

    commit(SET_PLAYLISTS, [playlist]);

    return playlist;
  }
};
